import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { Navigate } from 'react-router'
import { setAdminUser } from '../../services/reduxToolkit/adminUserLogin/actions';
import { setNewPage } from '../../services/reduxToolkit/PublicCurrentPage/actions';
import { setCurrentUser } from '../../services/reduxToolkit/userWithGoogle/actions';
import { AllRoutes } from './AllRoutes';

//Admin Restrictions
const isPageAdmin = (auth: string, secondary: string) => auth === "admin" && secondary === "user";

//Public Restrictions
const isPublic = (auth: string, secondary: string) => auth === "user" && secondary === "any";

interface PrivateRoutesProps {
    route: any;
    template: any;
    auth: string;
    altAuth: string;
    component: any;
    redirect: string;
    userData: any;
    path?: string;
    [key: string]: any;
}

export default function PrivateRoutes({route, template, auth, altAuth, component, redirect, userData, ...props}: PrivateRoutesProps) {
    const dispatch = useDispatch();
    useEffect(() => {
        switch (props.path) {
            case AllRoutes.home:
                    dispatch(setNewPage(0))
                break;
            case AllRoutes.aboutUs:
                    dispatch(setNewPage(2))
                break;
            case AllRoutes.programming:
                    dispatch(setNewPage(1))
                break;
            case AllRoutes.staff:
                    dispatch(setNewPage(4))
                break;
            case AllRoutes.gallery:
                    dispatch(setNewPage(3))
                break;
            default:
                break;
        }
        if(window.location.href.includes(AllRoutes.posts)) dispatch(setNewPage(5))
    }, [props.path, dispatch])

    const Layout = template;

    // Safe access to userData[1]
    const userAuth = userData?.[1];
    
    if(userAuth?.blocked) {
        dispatch(setAdminUser([null, {
            blocked: true,
            email: null,
            auth: "user",
            secondaryAuth: "any"
        }, false]))
        dispatch(setCurrentUser([null, {
            blocked: true,
            email: null,
            auth: "user",
            secondaryAuth: "any"
        }, false]))
        return <Navigate to={AllRoutes.blocked} replace />
    }
    
    // Check if user has valid auth data
    const userHasValidAuth = userAuth && userAuth.auth && userAuth.secondaryAuth;
    
    if(isPageAdmin(auth, altAuth)) {
        // Admin route - require admin auth
        if(userHasValidAuth && isPageAdmin(userAuth.auth, userAuth.secondaryAuth) && !userAuth.blocked)
            return <Layout Component={component} {...props} />
    }
    else if(isPublic(auth, altAuth)) {
        // Public route - allow if user has public auth OR if no auth data yet (not logged in)
        if(!userHasValidAuth || (isPublic(userAuth.auth, userAuth.secondaryAuth) && !userAuth.blocked))
            return <Layout Component={component} {...props} />
    }

    return <Navigate to={redirect} replace />
}
